import { useState } from "react";
import { Box, useTheme } from "@mui/material";
import { useInterval } from "@dvrt/react-tools";
import { useVideoEffectManager } from "./contexts/videoEffectContext";

const DebugInfoPanel = ({ track, showEffect = false }: { track: MediaStreamTrack; showEffect?: boolean }) => {
    const [settings, updateSettings] = useState(track.getSettings());
    const theme = useTheme();
    const { available, getRenderTime } = useVideoEffectManager();

    useInterval(() => {
        updateSettings(track.getSettings());
    }, 1000);

    return (
        <Box
            sx={{
                position: "absolute",
                top: 5,
                left: 5,
                backgroundColor: "rgba(10, 10, 10, 0.6)",
                padding: "3px 7px",
                borderRadius: theme.shape.borderRadius,
                backdropFilter: "blur(4px)",
                color: "white",
            }}
        >
            <table>
                <tbody>
                    <tr>
                        <td>width:</td>
                        <td>{settings.width}</td>
                    </tr>
                    <tr>
                        <td>height:</td>
                        <td>{settings.height}</td>
                    </tr>
                    <tr>
                        <td>fps:</td>
                        <td>{settings.frameRate?.toPrecision(4)}</td>
                    </tr>
                    {showEffect && available && (
                        <tr>
                            <td>effect:</td>
                            <td>{getRenderTime().toFixed(2)} ms</td>
                        </tr>
                    )}
                </tbody>
            </table>
        </Box>
    );
};

export default DebugInfoPanel;
